export enum UploadModalType {
  ATTACMENTS = "attachments",
  FILES = "files",
}
